export class UTF8 {
  EOF_byte = -1;
  EOF_code_point = -1;

  encoderError(code_point) {
  }

  decoderError(fatal, opt_code_point) {
    if (fatal) {
      return opt_code_point || 0xfffd;
    }
  }

  inRange(a, min, max) {
    return min <= a && a <= max;
  }

  div(n, d) {
    return Math.floor(n / d);
  }

  stringToCodePoints(string) {
    /** @type {Array.<number>} */
    let cps = [];
    // Based on http://www.w3.org/TR/WebIDL/#idl-DOMString
    let i = 0,
      n = string.length;
    while (i < string.length) {
      let c = string.charCodeAt(i);
      if (!this.inRange(c, 0xd800, 0xdfff)) {
        cps.push(c);
      } else if (this.inRange(c, 0xdc00, 0xdfff)) {
        cps.push(0xfffd);
      } else {
        // (inRange(c, 0xD800, 0xDBFF))
        if (i == n - 1) {
          cps.push(0xfffd);
        } else {
          let d = string.charCodeAt(i + 1);
          if (this.inRange(d, 0xdc00, 0xdfff)) {
            let a = c & 0x3ff;
            let b = d & 0x3ff;
            i += 1;
            cps.push(0x10000 + (a << 10) + b);
          } else {
            cps.push(0xfffd);
          }
        }
      }
      i += 1;
    }
    return cps;
  }

  encode(str) {
    const code = encodeURIComponent(str);
    const arr = [];
    for (let i = 0; i < code.length; i++) {
      const c = code.charAt(i);
      if (c === '%') {
        const hex = code.charAt(i + 1) + code.charAt(i + 2);
        const hexVal = parseInt(hex, 16);
        arr.push(hexVal);
        i += 2;
      } else {
        arr.push(c.charCodeAt(0));
      }
    }
    return new Uint8Array(arr);
  }

  decode(arr) {
    let encoded = '';
    for (let i = 0; i < arr.length; i++) {
      let s = arr[i] < 16 ? '%0' : '%';
      encoded += s + arr[i].toString(16);
    }
    try {
      return decodeURIComponent(encoded);
    } catch (e) {
      return this.decode1(arr);
    }
  }

  encode1(str) {
    let pos = 0;
    let codePoints = this.stringToCodePoints(str);
    let outputBytes = [];

    while (codePoints.length > pos) {
      let code_point = codePoints[pos++];

      if (this.inRange(code_point, 0xd800, 0xdfff)) {
        this.encoderError(code_point);
      } else if (this.inRange(code_point, 0x0000, 0x007f)) {
        outputBytes.push(code_point);
      } else {
        let count = 0,
          offset = 0;
        if (this.inRange(code_point, 0x0080, 0x07ff)) {
          count = 1;
          offset = 0xc0;
        } else if (this.inRange(code_point, 0x0800, 0xffff)) {
          count = 2;
          offset = 0xe0;
        } else if (this.inRange(code_point, 0x10000, 0x10ffff)) {
          count = 3;
          offset = 0xf0;
        }

        outputBytes.push(this.div(code_point, Math.pow(64, count)) + offset);

        while (count > 0) {
          let temp = this.div(code_point, Math.pow(64, count - 1));
          outputBytes.push(0x80 + (temp % 64));
          count -= 1;
        }
      }
    }
    return new Uint8Array(outputBytes);
  }

  decode1(array) {
    let out, i, len, c;
    let char2, char3;

    out = '';
    len = array.length;
    i = 0;
    while (i < len) {
      c = array[i++];
      switch (c >> 4) {
        case 0:
        case 1:
        case 2:
        case 3:
        case 4:
        case 5:
        case 6:
        case 7:
          // 0xxxxxxx
          out += String.fromCharCode(c);
          break;
        case 12:
        case 13:
          // 110x xxxx   10xx xxxx
          char2 = array[i++];
          out += String.fromCharCode(((c & 0x1f) << 6) | (char2 & 0x3f));
          break;
        case 14:
          // 1110 xxxx  10xx xxxx  10xx xxxx
          char2 = array[i++];
          char3 = array[i++];
          out += String.fromCharCode(
            ((c & 0x0f) << 12) | ((char2 & 0x3f) << 6) | ((char3 & 0x3f) << 0),
          );
          break;
      }
    }
    return out;
  }
}
/**字符串工具类 */
export default class StringUtils {
  /**
   * 替换format字符串中的所有 %s
   * 例如 printf('hello, %s!', 'dj') ==> 'hello, dj!'
   */
  static printf(format, ...params) {
    var str = '';
    var subs = format.split(/%s/);

    var last = subs.pop();
    if (last != '') {
      subs.push(last);
    }

    let len = subs.length < params.length ? subs.length : params.length;
    let i = 0;
    for (i = 0; i < len; ++i) {
      str += subs[i] + params[i];
    }

    if (subs.length > len) {
      i = len;
      len = subs.length;
      for (; i < len; ++i) {
        str += subs[i];
      }
    }

    return str;
  }

  /**
   * 忽略大小字母比较字符是否相等;
   * */
  static equalsIgnoreCase(char1, char2) {
    return char1.toLowerCase() == char2.toLowerCase();
  }

  patternrtrim = /\s*$/;

  /**
   * 比较字符是否相等;
   * */
  static equals(char1, char2) {
    return char1 == char2;
  }

  static patternltrim = /^\s*/;

  /**
   * 去左右空格;
   * */
  static trim(char) {
    if (char == null) {
      return null;
    }
    return StringUtils.rtrim(StringUtils.ltrim(char));
  }

  /**
   * 去左空格;
   * */
  static ltrim(char) {
    if (char == null) {
      return null;
    }

    return char.replace(StringUtils.patternltrim, '');
  }

  /**
   * 去右空格;
   * */
  static rtrim(char) {
    if (char == null) {
      return null;
    }

    return char.replace(StringUtils.patternrtrim, '');
  }

  /**
   * 是否是数值字符串;
   * */
  static isNumber(char) {
    if (char == null) {
      return false;
    }
    return !isNaN(parseInt(char));
  }

  /**
   * 替换指定位置字符;
   * */
  static replaceAt(char, value, beginIndex, endIndex) {
    beginIndex = Math.max(beginIndex, 0);
    endIndex = Math.min(endIndex, char.length);
    var firstPart = char.substr(0, beginIndex);
    var secondPart = char.substr(endIndex, char.length);
    return firstPart + value + secondPart;
  }

  /**
   * 删除指定位置字符;
   * */
  static removeAt(char, beginIndex, endIndex) {
    return StringUtils.replaceAt(char, '', beginIndex, endIndex);
  }

  /**替换 */
  static replace(char, replace, replaceWith) {
    return char.split(replace).join(replaceWith);
  }

  /**移除 */
  static remove(input, remove) {
    return StringUtils.replace(input, remove, '');
  }

  /**富文本 颜色 */
  static fontColor(info, color) {
    return '<color=' + color + '>' + info + '</color>';
  }

  /**
   * 通过时间获取时分秒（一般用来做倒计时）
   * @param time 时间(单位秒)
   * @param split 分割符（默认":"）
   */
  static doInverseTime(time, split = ':') {
    time = Math.round(time);
    var str = '';
    var second;
    var minute;
    var hour;
    if (time <= 0) {
      str = '00' + split + '00';
    } else {
      minute = Math.floor(time / 60);
      second = time % 60;
      if (minute <= 9) {
        str += '0' + minute + split;
      } else {
        str += minute + split;
      }
      if (second <= 9) {
        str += '0' + second;
      } else {
        str += second;
      }
    }
    return str;
  }

  /**
   * 将Date默认格式化为  “2000年1月1日00:00:00的形式”
   * @param time 时间戳(单位秒)
   * @param splite  分隔符
   */
  static formateTimeTo(time, splite = '/') {
    var date = new Date();
    date.setTime(time * 1000);
    var hour = date.getHours();
    var minute = date.getMinutes();
    var second = date.getSeconds();
    var hourStr = hour < 10 ? '0' + hour : hour + '';
    var minuteStr = minute < 10 ? '0' + minute : minute + '';
    var secondStr = second < 10 ? '0' + second : second + '';
    if (splite == '') {
      return (
        date.getFullYear() +
        StringUtils.getNianStr() +
        (date.getMonth() + 1) +
        StringUtils.getYueStr() +
        date.getDate() +
        StringUtils.getRiStr() +
        ' ' +
        hourStr +
        ':' +
        minuteStr +
        ':' +
        secondStr
      );
    } else {
      return (
        date.getFullYear() +
        splite +
        (date.getMonth() + 1) +
        splite +
        date.getDate() +
        ' ' +
        hourStr +
        ':' +
        minuteStr +
        ':' +
        secondStr
      );
    }
    //return "";
  }

  /**
   * 将Date默认格式化为  “6-29 00:00的形式”
   * @param time 时间戳(单位秒)
   * @param splite  分隔符
   */
  static formateTimeToDay(time, splite = '/') {
    var date = new Date();
    date.setTime(time * 1000);
    var hour = date.getHours();
    var minute = date.getMinutes();
    var second = date.getSeconds();
    var hourStr = hour < 10 ? '0' + hour : hour + '';
    var minuteStr = minute < 10 ? '0' + minute : minute + '';
    var secondStr = second < 10 ? '0' + second : second + '';
    if (splite == '') {
      return (
        date.getMonth() +
        1 +
        '/' +
        date.getDate() +
        ' ' +
        hourStr +
        ':' +
        minuteStr
      );
    } else {
      return (
        date.getMonth() +
        1 +
        '-' +
        date.getDate() +
        ' ' +
        hourStr +
        ':' +
        minuteStr
      );
    }
    //return "";
  }

  /**
   * 将Date默认格式化为  “2019/01/02”
   * @param time 时间戳(单位秒)
   * @param splite  分隔符
   */
  static formateTimeToYMD(time, splite = '/') {
    var date = new Date();
    date.setTime(time * 1000);
    return (
      date.getFullYear() +
      splite +
      (date.getMonth() + 1) +
      splite +
      date.getDate()
    );
  }

  /**
   * 返回是昨天还是今天或者其它日期
   * @param time 当前日期 毫秒
   * @param time1  指定日期 毫秒
   */
  static getTodayOrYesterdayOrOther(time, time1) {
    var date = new Date();
    date.setTime(time);

    var date1 = new Date();
    date1.setTime(time1);

    if (
      date.getFullYear() == date1.getFullYear() &&
      date.getMonth() == date.getMonth() &&
      date.getDate() == date1.getDate()
    ) {
      return ['今天', ''];
    }

    if (
      time1 -
      date1.getHours() * 3600 * 1000 -
      date1.getMinutes() * 60 * 1000 -
      date1.getSeconds() * 1000 -
      date1.getMilliseconds() +
      24 * 3600 * 1000 ==
      time -
      date.getHours() * 3600 * 1000 -
      date.getMinutes() * 60 * 1000 -
      date.getSeconds() * 1000 -
      date.getMilliseconds()
    ) {
      return ['昨天', ''];
    }

    return [date1.getDate() + '日', date1.getMonth() + 1 + '月'];
  }

  /**
   * 将时间转化为“01:00”的形式(time单位为毫秒)
   * @param time
   */
  static formatTimeToMFromMs(time) {
    var date = new Date();
    date.setTime(time);
    var hour = date.getHours();
    var minute = date.getMinutes();
    var miao = date.getSeconds();
    var hourStr = hour < 10 ? '0' + hour : hour + '';
    var minuteStr = minute < 10 ? '0' + minute : minute + '';
    var miaoStr = miao < 10 ? '0' + miao : miao + '';
    return hourStr + ':' + minuteStr + ':' + miaoStr;
  }

  static timecheck(num) {
    if (num < 10) {
      return '0' + num;
    }
    return '' + num;
  }

  static intToTime(sec) {
    let h = Math.floor(sec / 3600);
    let m = Math.floor((sec - h * 3600) / 60);
    let s = sec % 60;
    return (
      StringUtils.timecheck(h) +
      ':' +
      StringUtils.timecheck(m) +
      ':' +
      StringUtils.timecheck(s)
    );
  }

  static intToTime1(sec) {
    let h = Math.floor(sec / 3600);
    let m = Math.floor((sec - h * 3600) / 60);
    let s = sec % 60;
    return (
      (h > 0 ? StringUtils.timecheck(h) + ':' : '') +
      StringUtils.timecheck(m) +
      ':' +
      StringUtils.timecheck(s)
    );
  }

  static secondToTime(sec) {
    if (sec < 3600) {
      return Math.floor(sec / 60) + '分钟';
    } else {
      if (sec % 3600 == 0) {
        return sec / 3600 + '小时';
      } else {
        let tmp = Math.floor(sec / 360) / 10;
        return tmp + '小时';
      }
    }
  }

  //js截取字符串，中英文都能用
  //如果给定的字符串大于指定长度，截取指定长度返回，否者返回源字符串。
  //字符串，长度
  /**
   * js截取字符串，中英文都能用
   * @param str：需要截取的字符串
   * @param len: 需要截取的长度
   */
  static cutstr(str, len) {
    var str_length = 0;
    var str_len = 0;
    var str_cut = '';
    str_len = str.length;
    for (var i = 0; i < str_len; i++) {
      var a = str.charAt(i);
      str_length++;
      if (escape(a).length > 4) {
        //中文字符的长度经编码之后大于4
        str_length++;
      }
      str_cut = str_cut.concat(a);
      if (str_length >= len) {
        str_cut = str_cut.concat('.');
        return str_cut;
      }
    }
    //如果给定字符串小于指定长度，则返回源字符串；
    if (str_length < len) {
      return str;
    }
  }

  /**转换成中文数字 */
  static num2Cn1(value) {
    switch (value) {
      case 1: {
        return '一';
      }
      case 2: {
        return '二';
      }
      case 3: {
        return '三';
      }
      case 4: {
        return '四';
      }
      case 5: {
        return '五';
      }
      case 6: {
        return '六';
      }
      case 7: {
        return '七';
      }
      case 8: {
        return '八';
      }
      case 9: {
        return '九';
      }
      case 10: {
        return '十';
      }
      case 11: {
        return '十一';
      }
      case 12: {
        return '十二';
      }
      case 13: {
        return '十三';
      }
      case 14: {
        return '十四';
      }
      case 15: {
        return '十五';
      }
      case 16: {
        return '十六';
      }
    }
    return '';
  }

  static getDotInt(num) {
    let strArr = num.split('.');

    let str = strArr[0];
    let postfix = strArr.length > 1 && Number(strArr[1]) > 0 ? strArr[1] : '';
    let dotStr = '';
    let len = str.length;
    for (let i = len - 1; i >= 0; i--) {
      if ((len - i - 1) % 3 == 0 && len - i > 1) {
        dotStr = ',' + dotStr;
      }
      dotStr = str.charAt(i) + dotStr;
    }

    if (postfix != '') {
      dotStr += '.' + postfix;
    }
    return dotStr;
  }

  static getShowNumSign(num) {
    return num >= 0 ? '+' : '-';
  }

  static getNianStr() {
    return '年';
  }

  static getYueStr() {
    return '月';
  }

  static getRiStr() {
    return '日';
  }

  static utf = new UTF8();

  static encode(str) {
    return StringUtils.utf.encode(str);
  }

  static decode(arr) {
    return StringUtils.utf.decode(arr);
  }

  static units_c = [[100000000, '亿'], [10000, '万'], [1, '']];

  /**
   * 数字分隔
   */
  static ConvertInt2(num) {
    let flag = num >= 0 ? '' : '-';
    if (num < 100000) {
      return '' + num;
    }
    num = Math.abs(Number(num));
    let result;
    for (let i = 0; i < StringUtils.units_c.length; i++) {
      result = StringUtils.transform(num, StringUtils.units_c[i]);
      if (result[0]) {
        break;
      }
    }
    return flag + result[1];
  }

  static transform(num, unit) {
    if (num >= unit[0]) {
      if (num % unit[0] == 0) {
        num = num / unit[0] + unit[1];
      } else {
        num = (num / unit[0]).toFixed(1) + unit[1];
      }
      return [true, num];
    }
    return [false, num];
  }

  static adapterString(str, len) {
    let len1 = StringUtils.GetLength(str);
    if (len1 == len) {
      return str;
    }
    return StringUtils.CutString(str, len);
  }

  static CutString(str, len) {
    if (!str) {
      return '';
    }
    if (len <= 0) {
      return '';
    }
    var templen = 0;
    for (var i = 0; i < str.length; i++) {
      if (str.charCodeAt(i) > 255) {
        templen += 2;
      } else {
        templen++;
      }
      if (templen == len) {
        return str.substring(0, i + 1) + '...';
      } else if (templen > len) {
        return str.substring(0, i) + '...';
      }
    }
    return str;
  }

  static GetLength(str) {
    ///<summary>获得字符串实际长度，中文2，英文1</summary>
    ///<param name="str">要获得长度的字符串</param>
    var realLength = 0,
      len = str.length,
      charCode = -1;
    for (var i = 0; i < len; i++) {
      charCode = str.charCodeAt(i);
      if (charCode >= 0 && charCode <= 128) {
        realLength += 1;
      } else {
        realLength += 2;
      }
    }
    return realLength;
  }

  static randomNum2Num(num1, num2) {
    return num2 + Math.random() * (num1 - num2);
  }

  /**
   * 截取指定字节数
   * @param str 原始字符串
   * @param n 字节数
   */
  static adpterString(str, n) {
    if (str == null) {
      return str;
    }

    var size = 0;

    for (var i = 0; i < str.length; i++) {
      var db = str.charCodeAt(i).toString(16).length == 4;

      size += db ? 2 : 1;

      // //LogUtil.log("size-->"+size)

      if (size >= n) {
        return str.substring(0, i + 1) + (i + 1 == str.length ? '' : '..');
      }
    }

    return str;
  }

  static getByteByGMK(len) {
    if (len > 1024 * 1024 * 1024) {
      return (len / (1024 * 1024 * 1024)).toFixed(2) + 'GB';
    } else if (len > 1024 * 1024) {
      return (len / (1024 * 1024)).toFixed(2) + 'MB';
    } else if (len > 1024) {
      return (len / 1024).toFixed(2) + 'KB';
    } else {
      return len + 'B';
    }
  }

  static checkEmail(value) {
    var myReg = /^[a-zA-Z0-9_-]+@([a-zA-Z0-9]+\.)+(com|cn|net|org)$/;

    if (myReg.test(value)) {
      return true;
    } else {
      return false;
    }
  }

  static isEmpty(s) {
    return !(s && s != '');
  }

  static isNotEmpty(s) {
    return s && s != '';
  }

  static getShowNum(num) {
    return (num >= 0 ? '+' : '') + num;
  }

  // 当str长度超过某个限定值时，在str中插入换行符
  static spliceStr(str, max_len) {
    var len = str.length;
    if (len > max_len) {
      var pageSize = parseInt(len / max_len) + 1;
      var result = '';
      var start, end;
      for (var i = 0; i < pageSize; i++) {
        start = i * max_len;
        end = start + max_len;
        if (end > len) {
          end = len;
        }
        result += str.substring(start, end);
        result += '\n';
      }
      return result;
    } else {
      return str;
    }
  }

  static checkNum(txt = '') {
    return (
      txt
        .replace(/[^\d^\.?]+/g, '')
        .replace(/^0+(\d)/, '$1')
        .replace(/^\./, '0.')
        .match(/^\d*(\.?\d{0,4})/g)[0] || ''
    );
  }
}
